import type { FieldType } from '@/types/formSchema';

/** Enum/choice field types: the value is picked, not transcribed — no Heard affordance. */
const HEARD_INELIGIBLE: ReadonlySet<FieldType> = new Set<FieldType>([
  'select',
  'multi_select',
  'radio',
  'checkbox',
  'file',
]);

/**
 * Whether a field shows the "Heard" affordance. Heard is for values the rep says aloud
 * that the agent recovers from the recording later; enum/choice fields are picked
 * directly, so they get no Heard button. Array/object containers are never rendered as
 * a single editable field, so they are ineligible too.
 */
export function isHeardEligible(type: FieldType): boolean {
  if (type === 'array' || type === 'object') return false;
  return !HEARD_INELIGIBLE.has(type);
}
